<script setup>
  import { onBeforeMount, reactive, ref, watch } from 'vue'
  import { LabelField } from '@/components'

  const input = ref()

  const file = reactive({ upload: null, name: null, id: null })

  function handleInputChange({ target }) {
    file.upload = target.files[0]
    file.name = file.upload?.name
  }

  const props = defineProps({
    fileName: {
      type: String,
    },
    FileType: {
      type: String,
    },
    placeholderText: {
      type: String,
    },
    labelText: {
      type: String,
    },
    changeFile: {
      type: Function,
    },
    requiredField: {
      type: Boolean,
      default: false,
    },
    disabledField: reactive({
      type: Boolean,
      default: false,
    }),
    idField: {
      type: String,
      default: null,
    },
    addClass: {
      type: String,
      default: null,
    },
    accept: {
      type: String,
      required: false,
      default: 'image/*',
    },
    validarInput: reactive({
      type: Boolean,
      default: false,
    }),
  })

  onBeforeMount(() => {
    file.id = props.idField ? props.idField : props.FileType
  })

  watch(
    () => props.validarInput,
    async () => {
      if (!file.name && !props.fileName) {
        document.querySelector(`#${file.id}`).classList.add('isInvalid')
      }
    },
    { deep: true }
  )

  watch(
    () => file.name,
    async () => {
      document.querySelector(`#${file.id}`).classList.remove('isInvalid')
    },
    { deep: true }
  )
</script>

<template>
  <LabelField :label-text="labelText" class="mb-2" />
  <div :class="addClass" class="file-input arpen-input-file d-flex">
    <input
      :required="requiredField"
      type="text"
      :id="file.id"
      class="form-control"
      :class="!disabledField ? 'ChangeColorReadOnly' : ''"
      :value="file.upload?.name || fileName"
      @click="input.click()"
      :placeholder="placeholderText"
      :disabled="disabledField"
      readonly
    />
    <div
      @click="input.click()"
      class="file-input arpen-input-file-button d-flex justify-content-center align-items-center widhtEdit bg-secondary text-white fs-2 text"
    >
      +
    </div>
  </div>

  <input
    v-show="false"
    type="file"
    ref="input"
    id="input"
    :accept="accept"
    :required="requiredField"
    @change="
      (event) => {
        handleInputChange(event)
        changeFile(file.upload)
      }
    "
  />
</template>
